import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActiveModal } from '../../classes/active-modal';
import { Closeable } from '../../interfaces/closeable.interface';
import { Dismissable } from '../../interfaces/dismissable.interface';
import { MODAL_DISMISS_REASONS } from '../../modal-dismiss-reasons';
import { ActiveModalButtons } from '../../classes/active-modal-buttons';
import { ActiveModalLoader } from '../../classes/active-modal-loader';
import { Observable } from 'rxjs';
import { BUTTONS } from '../../../support/buttons';
import { trans } from '../../../localization/helpers';
import { __ } from '@kaiser-software/chassis-localization';

@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements Closeable, Dismissable, OnInit, OnDestroy {

    /**
     * The modal title.
     *
     * @type {string}
     */
    @Input() public title: string;

    constructor(public modal: ActiveModal, public buttons: ActiveModalButtons, public loader: ActiveModalLoader) {
        this.addButtons();

        this.modal.set('buttons', this.buttons);
    }

    protected addButtons() {
        this.buttons.add('ok', {
            text: trans('Ok'),
            classes: 'btn-primary',
            callback: () => {
                this.close();
            },
            loader: () => {
                return false;
            }
        });

        this.buttons.add('close', {
            text: __('Close'),
            classes: BUTTONS.CANCEL.CLASSES,
            icon: BUTTONS.CANCEL.ICON,
            callback: () => {
                this.dismiss();
            },
            loader: () => {
                return false;
            }
        });
    }

    public ngOnInit(): void {
        this.title = this.modal.get<string>('title')
            || this.title;
    }

    /**
     * Close the modal and gave an optional result.
     *
     * @param result
     */
    public close(result?: any): void {
        this.modal.close(result);
    }

    /**
     * Dismiss the modal and give an optional reason.
     *
     * @param reason
     */
    public dismiss(reason = MODAL_DISMISS_REASONS.CANCEL): void {
        this.modal.dismiss(reason);
    }

    /**
     * Indicates if `button` is disabled.
     *
     * @param button
     */
    public isButtonDisabled(button): Observable<boolean> {
        if (button.disabled instanceof Observable) {
            return button.disabled;
        }

        if (!(button.disabled instanceof Function)) {
            return Observable.of(false);
        }

        const disabled = button.disabled && button.disabled();

        if (typeof disabled === 'boolean') {
            return Observable.of(disabled);
        }

        return disabled;
    }

    /**
     * Indicates if `button` is loading.
     */
    public isButtonLoading(button): Observable<boolean> {
        if (button.loader instanceof Observable) {
            return button.loader;
        }

        if (!(button.loader instanceof Function)) {
            return Observable.of(false);
        }

        const loading = button.loader && button.loader();

        if (typeof loading === 'boolean') {
            return Observable.of(loading);
        }

        return loading;
    }

    public ngOnDestroy(): void {
        this.modal.dismiss();
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/components/modal/modal.component.ts